import Browser from '@wetransfer/transfer/modules/concorde-browser';
import Router from '@wetransfer/transfer/modules/router';

export const openProgressPanel = () => {
  Router.navigateTo('/transfer/progress', Router.SILENT);
};

export const shouldDisplayUpsellProgressPanel = (route) => {
  if (route.isPanelOpen) return false;
  if (Browser.isMobile) return false;

  return true;
};
